var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBloodDrop = function SvgBloodDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B02F2B",
    fillRule: "evenodd",
    d: "M9.533 1.809a.83.83 0 0 1 .933 0c.242.158 5.992 4.067 5.992 10.067a6.458 6.458 0 1 1-12.917 0c0-5.9 5.742-9.9 5.992-10.067M7.979 5.973C6.663 7.551 5.54 9.583 5.54 11.876a4.458 4.458 0 0 0 8.917 0c0-2.347-1.129-4.38-2.437-5.938a15 15 0 0 0-2.015-1.976q-.102.082-.215.18A15.6 15.6 0 0 0 7.98 5.973",
    clipRule: "evenodd"
  })));
};
export default SvgBloodDrop;